module.exports = __webpack_public_path__ + "media/customizations/meridiana/logo-new-50d4377e8d80e934ce7f9cc202ba6490.png";